import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  value: false,
  show: true,
  cartItems: 0
};

const cartSlice = createSlice({
  name: "cartItems",
  initialState,
  reducers:{
    setCart: (state, action)=>{
      state.cartItems = action.payload;
    }
  }
})

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});


const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    showAuth: (state, action) => {
      state.value = action.payload;
    },
  },
});


const authPageSlice = createSlice({
  name: "authPage",
  initialState: {
    value: "login",
  },
  reducers: {
    authPage: (state, action) => {
      state.value = action.payload;
    },
  },
});

const isShowingSlice = createSlice({
  name: "isShowing",
  initialState,
  
  reducers:{
    isShowing: (state, action)=>{
      state.show = action.payload
    }
  }
})

export const { showAuth } = authSlice.actions;
export const { setLoading } = loadingSlice.actions;
export const { authPage } = authPageSlice.actions;
export const {isShowing} = isShowingSlice.actions;
export const {setCart} = cartSlice.actions;

export const loadingReducer = loadingSlice.reducer;
export const authReducer = authSlice.reducer;
export const authPageReducer = authPageSlice.reducer;
export const isShowingReducer = isShowingSlice.reducer;
export const cartReducer = cartSlice.reducer;